import { render, staticRenderFns } from "./shouyin1.vue?vue&type=template&id=57660a16&scoped=true&"
import script from "./shouyin1.vue?vue&type=script&lang=js&"
export * from "./shouyin1.vue?vue&type=script&lang=js&"
import style0 from "./shouyin1.vue?vue&type=style&index=0&id=57660a16&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57660a16",
  null
  
)

export default component.exports